import { useContext } from "react";
import { useSelector } from "react-redux";

import { RightIcon } from "../../../client/assets/icons/thecreditreview/RightIcon";
import { getAwardText } from "../../../selectors";
import { BaseBenefitsList } from "../../BaseComponents/BaseBenefitsList";
import { BaseColumnInformation } from "../../BaseComponents/BaseColumnInformation";
import { BaseCompanyLogo } from "../../BaseComponents/BaseCompanyLogo";
import BaseCompanyName from "../../BaseComponents/BaseCompanyName";
import { BaseFeaturedCompanyHeader } from "../../BaseComponents/BaseFeaturedCompanyHeader";
import BaseLinkWrapper from "../../BaseComponents/BaseLinkWrapper";
import BaseProductDescription from "../../BaseComponents/BaseProductDescription";
import BaseReviewLink from "../../BaseComponents/BaseReviewLink";
import BaseServiceFlag from "../../BaseComponents/BaseServiceFlag";
import { BaseSocialProof } from "../../BaseComponents/BaseSocialProof";
import { BaseTrustpilotReview } from "../../BaseComponents/BaseTrustpilotReview";
import { BaseVisitLink } from "../../BaseComponents/BaseVisitLink";
import { CompanyContext } from "../../CompanyList/CompanyContext";
import { getStyles } from "./styles";

export const AutoRefinanceCompany = () => {
	const { company, companyIndex, isFeaturedCompany } =
		useContext(CompanyContext);
	const awardText = useSelector((state) => getAwardText(state, { company }));
	const styles = getStyles();

	return (
		<div
			className={`tw-relative tw-mt-[16px] tw-rounded-[3px] tw-bg-white desktop:[&:first-child]:tw-mt-[28px] ${isFeaturedCompany ? "[border:1px_solid_#0D8AE3]" : ""}`}
		>
			<BaseFeaturedCompanyHeader {...styles.featuredCompanyHeader} />
			<div className="tw-relative tw-mx-auto tw-flex tw-max-w-[500px] tw-flex-col tw-px-[16px] tw-py-[20px] desktop:tw-max-w-none desktop:tw-flex-row desktop:tw-p-[24px]">
				<BaseServiceFlag classNames={styles.serviceFlag} />

				<div
					className={`tw-flex tw-pt-[28px] desktop:tw-w-[30%] ${awardText ? "desktop:tw-py-12" : "desktop:tw-py-0"}`}
				>
					<BaseLinkWrapper className="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-[16px] desktop:tw-flex-col desktop:tw-justify-center desktop:tw-gap-[20px] [&:not(:has(>_div))]:tw-justify-center">
						<BaseCompanyLogo classNames={styles.companyLogo} />

						<BaseTrustpilotReview classNames={styles.trustpilotReview} />
					</BaseLinkWrapper>
				</div>

				<div className="tw-flex tw-flex-col tw-pt-[16px] desktop:tw-w-[70%] desktop:tw-flex-row desktop:tw-justify-between desktop:tw-gap-[20px] desktop:tw-p-0">
					<div className="tw-grow">
						<BaseCompanyName className="tw-hidden tw-font-[Montserrat] tw-text-[24px] tw-font-bold tw-leading-[32px] tw-tracking-[-0.48px] tw-text-[#333641] desktop:tw-block [&:not(:has(+_.peer-base-product-description))]:tw-mb-[16px]" />

						<BaseProductDescription className="peer-base-product-description tw-mb-[16px] tw-font-[Montserrat] tw-text-[20px] tw-font-semibold tw-leading-[32px] tw-tracking-[-0.4px] tw-text-[#333641]" />

						<BaseLinkWrapper className="tw-mb-[16px] tw-block tw-overflow-x-auto tw-scrollbar-none desktop:tw-mb-0">
							<BaseColumnInformation classNames={styles.columnInformation} />
						</BaseLinkWrapper>

						<BaseLinkWrapper className="tw-relative tw-inline-flex tw-h-[48px] tw-w-full tw-items-center tw-justify-center tw-gap-[12px] tw-rounded-[3px] tw-bg-[#70C25B] tw-text-[18px] tw-font-semibold tw-leading-[18px] tw-tracking-[-0.18px] tw-text-white tw-transition-all after:tw-h-[16px] after:tw-w-[16px] after:tw-bg-[url(/public/react-images/common/newTab.svg)] after:tw-bg-cover after:tw-bg-no-repeat hover:tw-bg-[#14a929] desktop:tw-hidden">
							<BaseVisitLink>View Rates</BaseVisitLink>
						</BaseLinkWrapper>

						{companyIndex === 0 && (
							<BaseSocialProof {...styles.mobileSocialProof} />
						)}

						<BaseLinkWrapper className="tw-mt-[24px] tw-block">
							<BaseBenefitsList
								{...styles.benefitsList}
								isExpandable={true}
								mobileItemsToShow={2}
							/>
						</BaseLinkWrapper>
					</div>

					<div className="tw-flex tw-flex-col tw-items-start tw-justify-center desktop:tw-items-center">
						{companyIndex === 0 && <BaseSocialProof {...styles.socialProof} />}

						<BaseLinkWrapper className="tw-relative tw-hidden tw-h-[48px] tw-w-full tw-items-center tw-justify-center tw-gap-[12px] tw-rounded-[3px] tw-bg-[#70C25B] tw-text-[18px] tw-font-semibold tw-leading-[18px] tw-tracking-[-0.18px] tw-text-white tw-transition-all after:tw-h-[16px] after:tw-w-[16px] after:tw-bg-[url(/public/react-images/common/newTab.svg)] after:tw-bg-cover after:tw-bg-no-repeat hover:tw-bg-[#14a929] desktop:tw-inline-flex desktop:tw-w-[175px] lg2:tw-w-[200px]">
							<BaseVisitLink>View Rates</BaseVisitLink>
						</BaseLinkWrapper>

						<BaseReviewLink
							classNames={styles.reviewLink}
							linkText="Read Full Review"
							prefixIcon={
								<RightIcon className="tw-text-[24px] desktop:tw-hidden" />
							}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
